import logger from './logger';
import {
  deflate,
  inflate,
} from 'pako';

export const compress = (data: object): Array<number> => {
  try {
    const encoder = new TextEncoder();
    const binaryData = encoder.encode(JSON.stringify(data));
    return Array.from(deflate(binaryData, { level: 9 }));
  } catch (error) {
    logger.error('Failed to compress data', error);
    return [];
  }
};

export const decompress = (data: Array<number>): object => {
  try {
    const decompressedData = inflate(new Uint8Array(data));
    const decoder = new TextDecoder();
    return JSON.parse(decoder.decode(decompressedData));
  } catch (error) {
    logger.error('Failed to decompress data', error);
    return {};
  }
};
